import { render } from "./LeadShow.vue?vue&type=template&id=7201907e&scoped=true"
import script from "./LeadShow.vue?vue&type=script&lang=js"
export * from "./LeadShow.vue?vue&type=script&lang=js"

import "./LeadShow.vue?vue&type=style&index=0&id=7201907e&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7201907e"]])

export default __exports__